import { ActivityIndicator, ScrollView, StyleSheet, Text, View } from 'react-native'
import { useState } from 'react'
import CustomButton from '../../shared/button/Button'
import Toast from 'react-native-toast-message'
import moment from 'moment'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useInitializeStore } from '../../../stores/initialize'
import { useFormsStore } from '../../../stores/onboarding'
import Card from '../../shared/card/Card'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import { globalStyles } from '../../../static/styles/global'
import Canvas from '../../canvas'
import SignatureFormView from '../SignatureFormView'


const WvInformationOnline = ({ navigation, route }) => {

    const {
        values,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
        total,
        LegalResidentState
    } = route.params

    const personalstore = usePersonalStore()
    const intializeStore = useInitializeStore()
    const { loading, postwvonline } = useFormsStore()



    const handlesubmit = async (signatureDataURL: any) => {
        const getMaritalStatus = (single: any, married: any) => {
            if (single !== undefined && single !== null && single !== '') return 1
            if (married !== undefined && married !== null && married !== '') return 0
            return null
        }
        const data = {
            entityId: personalstore?.personalData?.entityId,
            essUserKey: intializeStore?.initializeData?.userkey,
            essObKey: essUserOnBoardingKey,
            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
            completeOnline: true,
            sign: signatureDataURL,
            noOfExemptions:
                Number(values?.singleExemptions) +
                Number(values?.marriedExemptions) +
                Number(values?.dependentsExemption),
            specialWithholdingStatus: getMaritalStatus(values?.singleExemptions, values?.marriedExemptions),
            additionalWithholding: values?.additionalwithholding
                ? values?.additionalwithholding
                : 0,
            singleExemptions: values?.singleExemptions ? Number(values?.singleExemptions) : null,
            marriedExemptions: values?.marriedExemptions ? Number(values?.marriedExemptions) : null,
            dependentExemptions: values?.dependentsExemption ? Number(values?.dependentsExemption) : null,
            LowerWithheldRate: values?.specialWithholdingStatus,
            LegalResidentState: LegalResidentState

        }
        const response = await postwvonline(data)
        if (response?.success) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        }
        else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }

    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'WV Withholding Taxation'}
                    />
                </View>
            </View>

            <SignatureFormView
                essUserOnBoardingFormKey={essUserOnBoardingFormKey}
                essUserOnBoardingKey={essUserOnBoardingKey}
                isSubmitting={loading}
                onPrevious={() =>
                    navigation.navigate('WvInformationForm', {
                        essUserOnBoardingFormKey,
                        essUserOnBoardingKey,
                        values,
                        mode: "online",
                        LegalResidentState: LegalResidentState
                    })
                }
                onSubmit={handlesubmit}
                stateValue='WV'
            />

        </>
    )
}

export default WvInformationOnline
